document.addEventListener('DOMContentLoaded', function () {
    if (typeof window.Swiper != 'undefined') {
        const benefitsMarqueeWrappers = document.querySelectorAll('.benefits-marquee__slider.swiper');

        benefitsMarqueeWrappers.forEach((benefitsMarqueeWrapper) => {
            const benefitsMarqueeSlidesNumber = benefitsMarqueeWrapper?.querySelectorAll('.benefits-marquee__text')?.length;
            const isDesktop = window.innerWidth >= 850;
            let benefitsMarqueeSettings = {}

            if (isDesktop || benefitsMarqueeWrapper.dataset.autoscroll !== "true") {
                benefitsMarqueeSettings = {
                    watchSlidesProgress: true,
                    slidesPerView: "auto",
                    spaceBetween: Number(benefitsMarqueeWrapper.dataset.slideSpacing) || 80,
                    slidesOffsetAfter: isDesktop ? Number(benefitsMarqueeWrapper.dataset.desktopEndOffset) || 0 : 0,
                    grabCursor: false,
                    centeredSlides: false,
                    freeMode: true,
                    mousewheel: {
                        enabled: true,
                        forceToAxis: true,
                        releaseOnEdges: true,
                    },
                }
            } else {
                benefitsMarqueeSettings = {
                    loop: true,
                    slidesPerView: 'auto',
                    spaceBetween: Number(benefitsMarqueeWrapper.dataset.slideSpacing) || 40,
                    speed: 5000,

                    autoplay: {
                        delay: 0,
                        disableOnInteraction: false,
                    },

                    freeMode: true,
                    freeModeMomentum: false,

                    allowTouchMove: false,
                    simulateTouch: false,
                    touchStartPreventDefault: false,
                    touchStartForcePreventDefault: false,
                }
            }

            const benefitsMarqueeSlider = new Swiper(benefitsMarqueeWrapper, benefitsMarqueeSettings);
        });
    }
}, {once: true});
